import { useTranslation } from 'react-i18next';
import { Link } from 'react-router-dom';

import { Colors, Typography, createClasses } from '@kp/react-ui';

import { ROUTES } from '@/constants/routes';

const classes = createClasses({
  footer: {
    backgroundColor: Colors.Neutral.background,
    padding: '16px 120px',
    position: 'fixed',
    width: '100%',
    bottom: 0,
    left: 0,
    right: 0,
    zIndex: 100,
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    borderTop: `1px solid ${Colors.Neutral.border}`,
  },
  title: {
    color: Colors.Neutral.textWeak,
  },
  links: {
    display: 'flex',
    gap: '32px',
  },
  link: {
    textDecoration: 'none',
    color: Colors.Neutral.textWeak,
  },
  linkText: {
    color: Colors.Neutral.textWeak,
  },
});

export const Footer = () => {
  const { t } = useTranslation();
  return (
    <div className={classes.footer}>
      <Typography
        variant="bodySmall"
        className={classes.title}
        data-testid="title"
      >
        {t('footer.title')}
      </Typography>
      <div className={classes.links}>
        <Link
          to={ROUTES.legal('dataPrivacy')}
          className={classes.link}
          data-testid="privacy"
        >
          <Typography variant="bodySmall" className={classes.linkText}>
            {t('footer.privacy')}
          </Typography>
        </Link>
        <Link
          to={ROUTES.legal('termsAndConditions')}
          className={classes.link}
          data-testid="terms"
        >
          <Typography variant="bodySmall" className={classes.linkText}>
            {t('footer.terms')}
          </Typography>
        </Link>
        <Link
          to={ROUTES.legal('impressum')}
          className={classes.link}
          data-testid="imprint"
        >
          <Typography variant="bodySmall" className={classes.linkText}>
            {t('footer.imprint')}
          </Typography>
        </Link>
      </div>
    </div>
  );
};
